import { decodeVaultJwtPayload } from "./vaultActorSession";
import type {
  Requirement,
  Subfolder,
} from "../../redux/interfaces/folder.types";

const NATIVE_BDC_SUBFOLDERS = new Set([
  "tenant-pf",
  "tenant-pm",
  "guarantor-pf",
  "guarantor-pm",
  "guarantor-investigation-pf",
  "guarantor-investigation-pm",
]);

export function isNativeBdcSupported(
  requirement?: Requirement | null,
  subfolder?: Subfolder | null,
): boolean {
  if (!requirement || requirement.native_bdc_supported === false || !subfolder)
    return false;
  // Every additional participant carries this key, including the first extra.
  if (subfolder.metadata && "person_index" in subfolder.metadata) return false;
  return NATIVE_BDC_SUBFOLDERS.has(subfolder.slug.toLowerCase());
}

export type BdcParticipantActor = "tenant" | "guarantor";

export function decodeVaultJwtActor(jwtToken: string | null): string | null {
  const payload = decodeVaultJwtPayload(jwtToken);
  return typeof payload?.actor === "string"
    ? payload.actor.trim().toLowerCase()
    : null;
}

export function resolveBdcExpectedActor(
  subfolderSlug: string | null | undefined,
): BdcParticipantActor | null {
  if (!subfolderSlug) return null;
  return subfolderSlug.toLowerCase().includes("guarantor")
    ? "guarantor"
    : "tenant";
}

export function isBdcActorMismatch(
  jwtToken: string | null,
  subfolderSlug: string | null | undefined,
): boolean {
  const actualActor = decodeVaultJwtActor(jwtToken);
  const expectedActor = resolveBdcExpectedActor(subfolderSlug);
  const isTenantCompletingGuarantor =
    actualActor === "tenant" && expectedActor === "guarantor";
  return Boolean(
    actualActor &&
      expectedActor &&
      actualActor !== "advisor" &&
      actualActor !== expectedActor &&
      !isTenantCompletingGuarantor,
  );
}
